<div class="sign-in-web-form-wrapper">
	<div class="bg-default-color bg-properties">
		<div class="max-w-[1196px] flex grow flex-col">
			<ng-container *ngTemplateOutlet="header"></ng-container>
			<div class="grow">
				<ng-container *ngTemplateOutlet="body"></ng-container>
			</div>
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</div>

<ng-container *ngIf="modal">
	<app-web-kamona-message-widget
		[modalType]="modalType">
		<ng-container>
			<ng-container [ngSwitch]="customModal">
				<ng-container *ngSwitchDefault>
					<ng-container *ngTemplateOutlet="termsAndConditionsTemplate"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="PRIVACY">
					<ng-container *ngTemplateOutlet="privacyTemplate"></ng-container>
				</ng-container>
			</ng-container>
		</ng-container>
	</app-web-kamona-message-widget>
</ng-container>

<ng-template #body>
	<div class="mt-[100px] mx-auto max-w-[936px] gap-16 flex justify-center">
		<div class="basis-1/2">
			<div class="flex flex-col gap-[32px] max-w-[402px]">

			</div>
		</div>
		<div class="grow basis-1/2">
			<app-web-sign-in-form>
			</app-web-sign-in-form>
		</div>
	</div>
</ng-template>


<ng-template #footer>
	<div class="max-w-[939px] mx-auto pb-[43px] w-full text-[14px] font-medium text-[#808080] leading-[17.36px]">
		<div class="flex justify-between">
			<div  class="flex gap-[16px] basis-1/2">
				<div *ngIf="false" class="text-white" >About Moniepoint</div>
				<div class="cursor-pointer text-white" (click)="openPrivacy()">Privacy</div>
				<div class="cursor-pointer text-white" (click)="openTermsAndConditions()">Terms & Conditions</div>
			</div>
			<div class="basis-1/2">
				<div *ngIf="false" class="flex gap-[16px] justify-end">
					<div>Having any troubles?</div>
					<div class="text-[#0361F0]">Get Help</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #header>
	<div class="mt-[30px] w-full flex justify-between items-center">
		<div>
			<img src="assets/images/svgs/moniepoint-icon-and-label-white.svg">
		</div>
		<div class="flex gap-[12px] items-center">
			<div  class="text-[14px] leading-[19.6px] text-black font-normal">
				Already have an account?
			</div>
			<div (click)="signup()" class="bg-[#E6EEFD] cursor-pointer h-[46px] w-[137px] items-center flex justify-center rounded-[8px] py-[11px] px-[16px]">
				<div class="leading-[17.36px] text-[14px] font-medium text-[#0361F0]">
					Create account
				</div>
			</div>
		</div>
	</div>
</ng-template>


<ng-template #termsAndConditionsTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Terms and Conditions
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]" [innerHTML]="termsAndConditions?.content"></div>
			<div class="flex items-center justify-center">
				<div (click)="closeCustomModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #privacyTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Privacy Policy
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]">
				<app-privacy></app-privacy>
			</div>
			<div class="flex items-center justify-center">
				<div (click)="closeCustomModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>
